import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IconComponent } from '../icon/icon.component';

@Component({
  selector: 'icp-button',
  standalone: true,
  imports: [CommonModule, IconComponent],
  templateUrl: './icp-button.component.html',
  styleUrls: ['./icp-button.component.scss'],
})
export class IcpButtonComponent {
  @Input() label: string = '';
  @Input() iconName?: string;
  @Input() iconSrc?: string;
  @Input() iconPosition: 'left' | 'right' = 'left';
  @Input() variant: 'primary' | 'secondary' | 'outline' = 'primary';
  @Input() disabled: boolean = false;
  @Input() type: 'button' | 'submit' | 'reset' = 'button';
  @Input() fullWidth: boolean = false;
  @Input() backgroundColor?: string;
  @Input() textColor?: string;
  @Input() hoverBackgroundColor?: string;
  @Input() hoverTextColor?: string;
  @Output() click = new EventEmitter<MouseEvent>();

  onClick(event: MouseEvent): void {
    if (!this.disabled) {
      this.click.emit(event);
    }
  }
}

